export default __webpack_public_path__ + "static/media/cadeado.fc479531.svg";